import { InteractionType } from '@momentum/types';
import { Badge } from '@/shared/components/ui/Badge';
import { useTranslation } from 'react-i18next';

interface InteractionTypeBadgeProps {
  type: InteractionType;
  isDraft: boolean | undefined;
}

export const InteractionTypeBadge = ({
  type,
  isDraft,
}: InteractionTypeBadgeProps) => {
  const { t } = useTranslation('interactions');
  let interactionBadge: React.ReactNode = null;

  switch (type) {
    case InteractionType.PRAISE:
      interactionBadge = (
        <Badge className="bg-green-100 text-green-800 border-green-200 hover:bg-green-100 px-1.5 py-0.5 md:px-2.5 md:py-0.5 text-[10px] md:text-xs">
          {t('iSeeU')}
        </Badge>
      );
      break;
    case InteractionType.FEEDBACK:
      interactionBadge = (
        <Badge className="bg-primary/10 text-primary border-primary/20 hover:bg-primary/10 px-1.5 py-0.5 md:px-2.5 md:py-0.5 text-[10px] md:text-xs">
          {t('iNeedU')}
        </Badge>
      );
      break;
    case InteractionType.DEBRIEF:
      interactionBadge = (
        <Badge className="bg-purple-100 text-purple-800 border-purple-200 hover:bg-purple-100 px-1.5 py-0.5 md:px-2.5 md:py-0.5 text-[10px] md:text-xs">
          {t('iLearn')}
        </Badge>
      );
      break;
  }

  return (
    <div className="flex flex-col items-center space-y-0.5 md:space-y-1">
      {interactionBadge}
      {isDraft && (
        <Badge className="bg-gray-100 text-gray-800 border-gray-200 hover:bg-gray-100 px-1.5 py-0.5 md:px-2.5 md:py-0.5 text-[10px] md:text-xs">
          {'Draft'}
        </Badge>
      )}
    </div>
  );
};
